/**
 * Implements a Router5 middleware that handles successful routes and augments
 * them for use by the application.
 *
 * See: http://router5.github.io/docs/middleware.html
 */

import Radio from "backbone.radio";
import RouteModel from "../../models/route";

const channel = Radio.channel("global");

const RouteEmitter = (router, deps) => (toState, fromState, done) => {
  // localize store
  const { store } = deps;

  // console.log("toState", toState);

  // find this route's data
  let modelData = null;
  let child = null;
  const names = toState.name.split(".");
  const params = toState.params;
  const model = store.findWhere({ name: names[0] });

  if (model) {
    // console.log("Found top level route: %s", names[0], model.toJSON());

    // assume top level data
    modelData = model.toJSON();

    // unless its children have it
    if (model.has("children")) {
      child = _.findWhere(modelData.children, { name: names[1] });
      if (child) {
        // console.log("Found child route: %s", names[1], child);
        // use child as data
        modelData = child;
      }
    }

    // set model data with params when they exist, otherwise use original data
    modelData.data = !_.isEmpty(params) ? params : modelData.originalData;

    // augment toState object
    toState.data = modelData;
    toState.title = modelData.title;
    toState.subtitle = modelData.label;

    const routeModel = new RouteModel({
      route: toState.name,
      nav: toState.data,
      title: toState.title,
      subtitle: toState.subtitle,
    });

    // console.log("routeModel", routeModel.toJSON());

    // special handling
    switch (toState.name) {
      case "remove-custom-roles":
        channel.request("user:remove-custom-roles");
        break;

      default:
        break;
    }

    // announce route
    channel.trigger(model.get("category"), routeModel);
  }

  done();
};

export { RouteEmitter as default };
